
export default {
  'button_reset': 'Reset',
  'login': 'Se connecter',
  'email': 'E-mail',
  'password': 'Mot de passe',
  'home': 'Accueil',
  'global_yes': 'Oui',
  'global_no': 'No',
  'login_enter_mail_and_password': 'Entrez une adresse e-mail et un mot de passe valide.',
  'login_enter_valid_mail': 'Entrez une adresse e-mail valide.',
  'login_error': 'Une erreur s\'est produite lors du login. Veuillez réessayer plus tard ou contacter l\équipe de Terra si le problème persiste.',
  'login_error_email_not_registered': 'Cet e-mail n\'est pas enregistré',
  'login_error_password_not_correct': 'Ce mot de passe est incorrect',
  'login_password_forgot': 'J\'ai oublié mon mot de passe',
  'pw_required': 'Le mot de passe est requis',
  'pw_must_match': 'Les mots de passe doivent être identiques.',
  'pw_min_3_char': 'Le mot de passe doit avoir plus que 3 caractères.',
  'pw_min_4_char': 'Le mot de passe doit être composé d\'au moins 4 caractères.',
  'pw_incorrect': 'Le mot de passe n\'est pas correct',
  'register': 'S\'enregistrer',
  'reset_password_email_not_found': 'Cette adresse email n\'est pas enregistrée',
  'reset_password_enter_email': 'Entrez une adresse e-mail',
  'reset_password_error': 'Un erreur se produit. Contacte l\'administration terra.',
  'reset_password_go_to_login': 'Aller sur la page de login',
  'reset_password_instructions_sent': 'Un courriel a été envoyé à votre compte avec des instructions sur comment réinitialiser votre mot de passe.',
  'reset_password_send_submit': 'Envoyer les instructions',
  'reset_password_submit': 'Sauvegarder',
  'reset_password_success_message': "Excellent!<br>Le mot de passe a été modifié.",
  'reset_password_title': 'Réinitialiser votre mot de passe',
  'reset_password_title_send': 'Mot de passe oublié ?',
  'reset_password_token_invalid': 'Le lien n\est plus valide.',
  'setting_title': 'Données personnelles',
  'setting_email': 'Éditer adresse email',
  'setting_email_save': 'Enregistrez l\'email',
  'setting_email_success': 'L\'email a été bien modifié',
  'setting_password': 'Changer le mot de passe',
  'setting_password_save': 'Enregistrez le mot de passe',
  'setting_password_success': 'Le mot de passe a été bien modifié',
  'setting_current_pw': 'Mot de passe actuel',
  'setting_new_pw': 'Nouveau mot de passe',
  'setting_confirm_new_pw': 'Confirmez le mot de passe',
  'setting_profile': 'Coordonnées',
  'setting_profile_save': 'Enregistrez le profil',
  'setting_profile_success': 'Le profil a été bien modifié',
  'sign_up_confirm_pw': 'Confirmez mot de passe',
  'sign_up': 'S\'enregister',
  'sign_up_alert_registrations_closed_1': 'Désolés, les inscriptions pour devenir membre en 2019 sont clôturées.',
  'sign_up_alert_registrations_closed_2': 'Néanmoins, vous pouvez vous enregistrer et nous vous contacterons dés qu\'une place se libère.',
  //'sign_up_accept': 'J’accepte que TERRA utilise mes données personnelles en accord avec le RGPD. Plus d’information sur la protection de données de TERRA ',
  'sign_up_accept': 'J’accepte que TERRA utilise mes données personnelles en accord avec ',
  'sign_up_policy': 'la protection de données de TERRA',
  'signup_policy_link': 'contactez-nous',
  'email_valid': 'Ceci n\'est pas une adresse valide.',
  'email_required': 'Votre adresse e-mail?',
  'email_error_exist': 'L\'adresse email fourni est déjà utilisée',
  'email_error_other': 'Une erreur est apparue dans ce champ',
  'first_name': 'Prénom',
  'first_name_required': 'Un prénom est requis',
  'last_name': 'Nom',
  'last_name_required': 'Un nom est requis',
  'phone_number': 'Téléphone',
  'phone_number_required': 'Un numéro de téléphone est requis',
  'phone_number_max': 'Le numéro de téléphone est trop long',
  'address1': 'Adresse',
  'address1_required': 'Une adresse est requis',
  'address2': 'Adress 2',
  'zip': 'CP',
  'zip_required': 'Le code postal est requis',
  'city': 'Ville',
  'city_required': 'Une ville est requis',
  'country': 'Pays',
  'country_required': 'Un pays est requis',
  'data_authorization': 'Je suis d\'accord que TERRA utilise mes informations personnelle dans le domaine de TERRA',
  'pickup_option': 'Lieu de distribution',
  'pickup_option_required': 'Le lieu de distribution est requis',
  'date': 'Date',
  'main_commit': 'Je m\'engage à',
  'main_commit_text_1': 'Être membre pendant la  saison actuelle entière, même si je paye en plusieurs versements',
  'main_commit_text_2': 'Régler la cotisation de membre dûment et dans les délais fixés',
  'main_commit_text_3': 'Récupérer ma part de la récolte toutes les semaines',
  'main_logo_image': 'TERRA-ASCblanc.png',
  'main_membership_entitles': 'Chaque adhésion donne droit à 1 part de la récolte',
  'main_slogan_1': 'Ici vous devenez membre!',
  'main_slogan_2': 'Ici vous gérez vos légumes!',
  'main_title': 'TERRA',
  'main_subtitle': 'Agriculture Soutenue par la Communauté (ASC)',
  'main_signup': 'INSCRIS-TOI',
  'main_signup_message': 'Rejoins l\'aventure TERRA maintenant!',
  'main_login': 'LOGIN',
  'main_login_message': 'Si tu es déjà membre de TERRA!',
  'main_as_member': 'EN TANT QUE MEMBRE',
  'main_rights': 'J\'ai droit à',
  'main_rights_text_1': 'Recevoir une part des récoltes de TERRA pendant la saison actuelle',
  'main_rights_text_2': 'Participer à un prix réduit aux ateliers proposés par TERRA (-10%)',
  'main_rights_text_3': 'Participer aux festivités et aux activités dans les champs de TERRA',
  'main_understand': 'Je comprends que',
  'main_understand_text_1': 'Les récoltes sont sujettes à des variations saisonnières, à des risques naturels et à l\'expérience des producteurs',
  'main_understand_text_2': 'Les producteurs assurent de leur mieux des récoltes abondantes et d\'une qualité excellente',
  'main_understand_text_3': 'Le début et la fin exactes de la saison varient selon les conditions (environ fin avril à début décembre)',
  'main_video_title': 'Voici comment fonctionne Terra !',
  'main_video_legend': 'Vidéo réalisée par Carles Xiberta',
  'footer_contact_label': 'Contact',
  'footer_address_label': 'Jardin de Terra',
  'footer_postal_address_label': 'Adresse Postale',
  'footer_account_label': 'compte bancaire',
  'footer_follow_us_label': 'Suivez-nous',
  'membership_at': ' à ',
  'membership_from': ' de ',
  'membership_to': ' à ',
  'membership': 'Cotisation',
  'membership_alert_no_registrations': 'Nous ne prenons pas encore les inscriptions pour la saison prochaine',
  'membership_alert_no_basket_1': 'Inscriptions ouvertes!',
  'membership_alert_no_basket_2': 'Tu n\'es pas encore enregistré(e) pour un panier pendant la saison ',
  'membership_alert_no_payment_1': 'En attente du paiement!',
  'membership_alert_no_payment_2': 'Nous n\'avons pas encore reçu de paiement pour ton panier en ',
  'membership_amount': 'Montant',
  'membership_basket': 'Panier',
  'membership_basket_active': 'Actif',
  'membership_basket_waiting_payment': 'En attente de paiement',
  'membership_basket_waiting_activation': 'En attente d\'activation',
  'membership_baskets': 'panier(s)',
  'membership_button_edit': 'Editer le profil',
  'membership_button_create_basket': 'Créer un nouveau panier',
  'membership_season_label': 'Saison',
  'membership_open_registration_label': 'Les inscriptions sont ouvertes pour la saison',
  'membership_date': 'Date',
  'membership_deadline': 'Échéance',
  'membership_deadline_approaching': 'Date d\'échéance de paiement est proche',
  'membership_description': 'Ici vous gérez vos paniers et vos produits extra',
  'membership_every': 'Tous les ',
  'membership_extras': 'Extras',
  'membership_first_pickup': 'Début de la saison',
  'membership_last_pickup': 'Fin de la saison',
  'membership_name': 'Nom',
  'membership_payment': 'Paiement',
  'membership_paid': 'Paiement reçu',
  'membership_phone': 'Téléphone',
  'membership_total': 'Total à payer',
  'membership_baskets_alert_activated_1': 'Panier actif',
  'membership_baskets_alert_activated_2': 'C\'est seulement possible editer le lieu de distribution',
  'membership_baskets_create': 'Ajouter panier',
  'membership_baskets_edit': 'Editer panier',
  'membership_baskets_emails_title': 'Adresses e-mail supplémentaires',
  'membership_baskets_emails_text': 'Si vous voulez recevoir les emails destinés aux membres de TERRA à une addresse email supplémentaire, veuillez l\'indiquer ci-dessous.',
  'membership_baskets_extras': 'Extras',
  'membership_baskets_extra_disabled': 'Indisponible',
  'membership_baskets_member_type_title': 'Je suis ...',
  'membership_baskets_member_type_required': 'Le type de membre est requis',
  'membership_baskets_member_type_option_returning': '... ancien membre.',
  'membership_baskets_member_type_option_new': '... nouveau membre.',
  'membership_baskets_member_type_reference': 'Si tu as connu TERRA gràce à un(e) autre membre, merci de nous communiquer son nom ici, ainsi on pourra lui dire merci:',
  'membership_baskets_member_type_reference_required': 'Le nom du membre est requis',
  'membership_baskets_more_info': '... plus d\'information',
  'membership_baskets_num_payments': 'Nombre de paiements',
  'membership_baskets_payment_deadlines' : 'Échéance des paiements',
  'membership_baskets_deadline_1': 'Première échéance',
  'membership_baskets_deadline_2': 'Deuxième échéance',
  'membership_baskets_deadline_3': 'Troisième échéance',
  'membership_baskets_deadline_4': 'Quatrième échéance',
  'membership_baskets_prices_title': 'Options de cotisation',
  'membership_baskets_prices_required': 'L\'option de cotisation est requis',
  'membership_baskets_subtitle': '',
  'membership_baskets_create_title': 'Créez votre panier',
  'membership_baskets_edit_title': 'Editez votre panier',
  'membership_baskets_total': 'Total',
  'membership_edit_save': 'Enregistrer',
  'membership_edit_title': 'Editer le Profil',
  'schedule': 'Calendrier',
  'schedule_alert_active_no_basket': 'Tu n’a pas un panier TERRA actif pour la saison actuelle',
  'schedule_alert_no_active_no_registrations_title': 'Bonjour,',
  'schedule_alert_no_active_no_registrations': 'Nous te remercions pour ton intérêt de devenir membre de TERRA!<br>Les inscriptions pour la saison 2021 sont malheureusement clôturées!<br>Tu pourras profiter tout de même de nos légumes en visitant le stand de TERRA à Bonnevoie sur la place Léon XIII, chaque samedi entre 10h et 12h (de mai au début décembre).<br>Et qui sait, tu voudras peut-être t’inscrire comme membre l’année prochaine?<br>À bientôt !<br>L’équipe de TERRA',
  'schedule_alert_registrations_no_basket_title': 'Inscriptions ouvertes!',
  'schedule_alert_registrations_no_basket': 'Tu peux t\'enregistrer maintenant pour devenir membre pendant la saison prochaine.. <strong>Click ici.</strong>',
  'schedule_alert_no_payment_1': 'En attente du paiement!',
  'schedule_alert_no_payment_2': 'Nous n’avons pas encore reçu de paiement pour ton panier de la saison prochaine. Plus de détails ici!',
  'schedule_help_out_button': 'Je veux aider',
  'schedule_help_out_remove_button': 'Je ne peux pas aider',
  'schedule_help_out_instruction_title': 'Tu t\'es inscrit(e) pour aider lors de cette distribution.',
  'schedule_help_out_instruction': 'Nous te prions de venir 20 mins. avant le commencement de la distribution et de rester jusqu\'à la fin. Merci pour ton aide!',
  'schedule_help_out_title': 'Est-ce que tu veux t\'inscrire pour aider lors de cette distribution?',
  'schedule_alert_open_registrations_1': 'Registration ouvert pour la prochaine saison!',
  'schedule_alert_open_registrations_2': 'Tu n\'es pas encore inscrit(e) pour la prochain saison, si tu souhaites rester membre pendant la prochaine saison, veuillez cliquer ici',
  'schedule_change_default': 'Changer le lieu de distribution par défaut',
  'schedule_loading': 'Chargement en cours...',
  //'schedule_info_and_options': 'Option de distribution',
  'schedule_location': 'Lieu:',
  'schedule_pickup_note': 'Note:',
  'schedule_will_be_pickedup_by': 'Sera récupéré par:',
  'schedule_cannot_pickup': 'Je ne peux pas venir',
  'schedule_user_note': 'Remarque:',
  'schedule_note': 'Note:',
  'schedule_move_to': 'Changer à:',
  'schedule_wont_come': 'Je ne peux pas venir.',
  'schedule_properties': 'Effectuer des changements pour votre distribution.',
  'schedule_delegate': 'Déléguer:',
  'schedule_not_default_location': 'La distribution ne sera pas faite à l\'endroit habituel',
  'schedule_pickup_contact': 'Contact de distribution',
  'delegate_name': 'Nom',
  'default': 'défaut',
  'save': 'Enregistrer',
  'cancel': 'Annuler',
  'edit': 'Modifier',
  'picked_up': 'A été récupéré',
  'not_picked_up': 'N\'a pas été enlever',
  'pickup_location_map': 'Carte du lieu de la distribution',
  'select_alternative': 'Choisissez une alternative',
  'default_title': 'Point de distribution par défaut',
  'default_only_future': 'Seulement les distributions futures seront affectés.',
  'default_detail_start': 'Je veux avoir mon ',
  'default_detail_end': '. panier à:',
  'select_pickup_option': 'Sélectionnez une option',
  'day_0': 'Dimanche',
  'day_1': 'Lundi',
  'day_2': 'Mardi',
  'day_3': 'Mercredi',
  'day_4': 'Jeudi',
  'day_5': 'Vendredi',
  'day_6': 'Samedi',
  'shortmonth_0': 'Jan',
  'shortmonth_1': 'Fév',
  'shortmonth_2': 'Mar',
  'shortmonth_3': 'Avr',
  'shortmonth_4': 'Mai',
  'shortmonth_5': 'Jui',
  'shortmonth_6': 'Jul',
  'shortmonth_7': 'Aou',
  'shortmonth_8': 'Sep',
  'shortmonth_9': 'Oct',
  'shortmonth_10': 'Nov',
  'shortmonth_11': 'Déc'
};



// WEBPACK FOOTER //
// ./client/app/services/translation/translation.fr.ts